import React from "react";
import { useAppContext } from "../context/AppContext";
import { Phone, Mail, MapPin, Facebook, Youtube, Instagram } from "lucide-react";
import Logo from "../assets/logo.png";
import { FooterTrans, HeaderTrans } from "../utils/translations";

const columnTitleClass = "text-xs font-semibold uppercase tracking-wide text-ink-mid mb-3 text-center md:text-left";

const Footer = () => {
  const { language, country } = useAppContext();
  const trans = FooterTrans[language] || FooterTrans.english;

  return (
    <footer className="w-full mt-5 border-t border-[#D0BFAE] px-4 md:px-0 py-8">
      <div className="md:w-10/12 mx-auto grid sm:grid-cols-2 md:grid-cols-4 gap-8 text-sm text-center md:text-left">
        {/* Brand */}
        <div>
          <a href="/landing" className="flex items-center gap-2 justify-center md:justify-start mb-2">
            <img className="w-10 h-auto" alt="Once up on a mat" src={Logo} />
            <span className="font-serif text-base text-pink">
              {HeaderTrans[language].onceUp} <span className="text-black">{HeaderTrans[language].onMat}</span>
            </span>
          </a>
          <p className="text-ink-light text-xs">{trans.rights}</p>
        </div>

        {/* Contacts */}
        <div>
          <h4 className={columnTitleClass}>{trans.contact}</h4>
          <ul className="flex flex-col gap-2 text-ink-mid text-xs">
            <li className="flex items-center justify-center md:justify-start gap-2">
              <Phone size={14} className="shrink-0" /> +972 55 911 69 75
            </li>
            <li className="flex items-center justify-center md:justify-start gap-2">
              <Mail size={14} className="shrink-0" />
              <a href="mailto:anna.joy.inbox@gmail.com" className="hover:text-pink">anna.joy.inbox@gmail.com</a>
            </li>
            <li className="flex items-center justify-center md:justify-start gap-2">
              <MapPin size={14} className="shrink-0" /> Ramat Gan, Jabotinsky, 103
            </li>
            {country === "RU" && <li>Соколик Анна Александровна ИНН 503228030509</li>}
          </ul>
        </div>

        {/* Documents */}
        <div>
          <h4 className={columnTitleClass}>{trans.documents}</h4>
          <ul className="flex flex-col gap-2 text-ink-mid text-xs">
            <li>
              <a
                href="https://docs.google.com/document/d/1LpZBMAgSNKdRFbY5EvF1_jITyPkqX9qw/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink hover:underline"
              >
                {trans.docPrivacy}
              </a>
            </li>
            <li>
              <a
                href="https://docs.google.com/document/d/1N-FdV1XnIO_ctkZWrrSlXIPeud_ccFxr/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink hover:underline"
              >
                {trans.docTermsSales}
              </a>
            </li>
            <li>
              <a
                href="https://docs.google.com/document/d/1oIk1TyyRwGe_gy0Ak0nxX_ekU0uaFX93/edit?usp=sharing&ouid=105546982432366953063&rtpof=true&sd=true"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink hover:underline"
              >
                {trans.docTermsService}
              </a>
            </li>
            <li>
              <a
                href="https://drive.google.com/file/d/1hl3btMBusjFS7r7AEsxqv6bomoSbr4Nn/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink hover:underline"
              >
                {trans.docLicense}
              </a>
            </li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h4 className={columnTitleClass}>{trans.followUs}</h4>
          <div className="flex items-center justify-center md:justify-start gap-4">
            <a href="https://www.facebook.com/theanyajoy" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-ink-mid hover:text-pink transition-colors">
              <Facebook size={18} />
            </a>
            <a href="https://www.youtube.com/@once-up-on-a-mat" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-ink-mid hover:text-pink transition-colors">
              <Youtube size={18} />
            </a>
            <a
              href={
                language === "russian"
                  ? "https://www.instagram.com/joykayoga/"
                  : "https://www.instagram.com/once.up.on.a.mat"
              }
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-ink-mid hover:text-pink transition-colors"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="md:w-10/12 mx-auto md:-mt-6 mt-4 text-center md:text-left">
        <a href="https://tends.me" target="_blank" rel="noreferrer" className="text-xs text-ink-light hover:opacity-80">
          {trans.poweredBy} <span className="text-black">tends</span><span style={{ color: "#5C2E0E" }}>.me</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
